<template>
  <div :class="$style.wrap">
    <div :class="$style.inner">
      <div
        :class="[
          'el-input',
          `el-input--${size}`,
          'el-input--suffix',
          'department_lh25',
          { 'is-disabled': disabled, },
          value && clearable ? $style.hasValue : ''
        ]"
        @click="openDialog"
      >
        <input
          type="text"
          readonly="readonly"
          autocomplete="off"
          :placeholder="placeholder"
          class="el-input__inner"
          :value="label"
          @click.stop="openDialog"
        />
        <span class="el-input__suffix">
          <span class="el-input__suffix-inner">
            <i :class="$style.iconArrow" class="icon-arrow el-select__caret el-input__icon el-icon-arrow-up" style="transform: rotate(180deg)"></i>
            <i @click.stop="onClear" v-if="clearable" :class="$style.iconClose" class=" el-select__caret el-input__icon el-icon-circle-close"></i>
          </span>
        </span>
      </div>
    </div>
    <el-dialog
      :visible="show"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
      :width="person ? '800px' : '400px'"
      center="center"
    >
      <div :class="$style.dialogWrap">
        <div :class="$style.treeWrap">
          <el-tree
            :data="depTree"
            :props="defaultProps"
            @node-click="changeDepartment"
            node-key="id"
            :default-expand-all="defaultExpandAll"
            @check="checkDepartment"
            highlight-current
            :expand-on-click-node="false"
            show-checkbox
            :check-strictly="true"
            ref="tree"
          ></el-tree>
        </div>

        <div :class="$style.tableWrap" v-if="person" class="department_com">
          <div>当前部门 : {{ currentDep ? currentDep.full_name : "-" }}</div>
          <el-table
            :data="list"
            ref="tableRef"
            :max-height="500"
            highlight-current-row
            @current-change="changePerson"
          >
            <el-table-column prop="username" label="工号" width="100">
              <template v-slot="{ row }">
                <span @click.stop="spanChangePerson(row)">{{ row['username'] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="realname" label="姓名" width="150">
            </el-table-column>
            <el-table-column prop="title" label="职位" width="150">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="close">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeps,
  getDepartmentsTree,
  getDepFullName,
  getDepOptions,
} from "@/modules/departments";
import { getUser } from "./api";
import { getBasicInfo } from "@/modules/user";
import { ROLE } from "@/modules/entities";
export default {
  name: "Departments",
  props: {
    options: {
      type: Object,
      default() {
        return getDepOptions()[getBasicInfo().role];
      },
    },
    person: {
      //是否选人
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      default: null,
    },
    status: { // 传0查全部，传非0查在职的
      type: Number,
      default: 0,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'medium'
    }
  },
  data() {
    return {
      show: false,
      defaultProps: {
        children: "children",
        label: "name",
      },
      list: [],
      currentDep: null,
      currentUser: null,
      center: undefined, //中心标记 0-无标记 1-有中心
      depLevel: undefined, //级别 0-普通 1-初级 2-高级
      depType: undefined, //类型 0-无 1-前端 2-后端
      branch: undefined, //中心 0-无 1-一中心 2-二中心 3-小额 4-三中心
      includes: undefined, //该full_ids包含账号id, true: 只包含当前组织架构
      other: [], //除该角色所匹配以外的部门
    };
  },
  async beforeMount() {
    if (this.person && !!this.value) {
      this.currentDep = getDeps()[this.value.dep];
      await this.getUser(this.value.dep);
      this.currentUser = this.list.filter((item) => {
        return `${item.id}` === `${this.value.person}`;
      })[0];
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.formatOptions = {
          ...getDepOptions()[getBasicInfo().role],
          // branch: this.getDefaultBranch(),
          ...this.options,
        };
        let {
          center = undefined,
          depLevel = undefined,
          depType = undefined,
          branch = undefined,
          includes = undefined,
          other = [],
        } = this.formatOptions;
        this.center = center;
        this.depLevel = depLevel;
        this.depType = depType;
        this.branch = branch;
        this.includes = includes;
        this.other = other;
        //合规管理员清空默认值
      }
    },
  },
  computed: {
    defaultExpandAll() {
      return [
        ROLE.FRONT_ADVISER,
        ROLE.FRONT_TRAINEE_DIRECTOR,
        ROLE.FRONT_DIRECTOR,
        ROLE.FRONT_MANAGER,
        ROLE.BACK_ADVISER,
        ROLE.BACK_TRAINEE_DIRECTOR,
        ROLE.BACK_DIRECTOR,
        ROLE.BACK_MANAGER,
        ROLE.COMPLAINT_SPECIALIST,
        ROLE.COMPLAINT_SUPERVISOR,
      ].includes(getBasicInfo().role)
    },
    dep() {
      return getDeps();
    },
    depTree() {
      return getDepartmentsTree({
        center: this.center,
        depType: this.depType,
        depLevel: this.depLevel,
        branch: this.branch,
        includes: this.includes,
        other: this.other,
      });
    },
    label() {
      if (this.person) {
        return !this.currentUser ? "" : this.currentUser.realname;
      } else if (this.value instanceof Array) {
        let str = this.value.reduce((total, item) => {
          return total + `${getDepFullName(item)},`;
        }, "");
        return str.substring(0, str.length - 1);
      } else {
        return this.value ? getDepFullName(this.value) : "";
      }
    },
  },
  methods: {
    getDefaultBranch() {
      /**
       * 暂时不需要了INTERENT_ANALYST的限制了
       * 数据岗的前后端默认只能看到对应前后端的一中心
       * ROLE.INTERENT_ANALYST 数据岗
       * this.options.depType: 1是前端， 2是后端
       * getBasicInfo().isFrontend: 1是前端，否则是后端
       * 
       */
      if (!this.options.depType && getBasicInfo().role === ROLE.INTERENT_ANALYST) {
        return 1
      }
      if (this.options.depType === 1 &&
        getBasicInfo().role === ROLE.INTERENT_ANALYST &&
        getBasicInfo().isFrontend === 1
      ) {
          return 1
      }
      if (this.options.depType === 2 &&
        getBasicInfo().role === ROLE.INTERENT_ANALYST &&
        getBasicInfo().isFrontend !== 1
      ) {
          return 1
      }
      return undefined
    },
    openDialog() {
      if (this.disabled) return;
      this.show = true;
      this.list = [];
      this.$refs.tree?.setCheckedKeys([]);
    },
    submit() {
      if (!this.person) {
        if (!this.currentDep) {
          this.$message.error("请选择组织架构");
          return;
        }
      } else {
        if (!this.currentUser || !this.currentUser.realname) {
          this.$message.error("请选择人员");
          return;
        }
      }
      let value;
      if (this.currentDep instanceof Array) {
        value = this.currentDep.map((item) => {
          return item.id;
        });
      } else {
        value = this.person
          ? {
              person: this.currentUser.id,
              personTitle: this.currentUser.title,
              dep: this.currentDep.id,
            }
          : this.currentDep.id;
      }

      this.$emit("update:value", value);
      this.$emit("change", value);
      this.close();
    },
    onClear() {
      this.list = [];
      this.currentDep = null;
      this.currentUser = null;
      this.$refs.tree?.setCheckedKeys([]);
      this.$emit("update:value", "");
    },
    clear() { // 暴露给外部的方法
      this.onClear()
    },
    changeDepartment(item) {
      // if (!item.disabled) {
      //   this.currentDep = item;
      //   this.list = [];
      //   this.getUser(item.id);
      // }
    },
    checkDepartment(item, node, self) {
      if (!node) return;
      if (this.multiple) {
        this.$refs.tree?.setChecked(node);
        let arr = Array.from(new Set(this.$refs.tree.getCheckedKeys()));
        this.currentDep = arr.map((item) => {
          return getDeps()[item];
        });
      } else {
        this.$refs.tree?.setCheckedKeys([item.id]);
        this.currentDep = item;
        this.list = [];
        this.getUser(item.id);
      }
    },
    changePerson(item) {
      console.log('changePerson', item);
      if (!item) return;
      this.currentUser = item;
    },
    spanChangePerson(item) {
      console.log('spanChangePerson', item);
      if (!item) return;
      this.$refs.tableRef.setCurrentRow(item)
      this.currentUser = item;
    },
    async getUser(dep_id) {
      let { data } = await getUser({ dep_id, status: this.status });
      this.list = data;
    },
    close() {
      this.show = false;
    },
    initCurrentDep() {
      this.$nextTick(() => {
        this.$refs.tree?.setCheckedKeys(this.value);
      });
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  display: inline-block;
}
.inner {
  cursor: pointer;
}
.dialogWrap {
  display: flex;
}
.treeWrap {
  flex: 1;

  padding-right: 20px;
  height: 400px;
  overflow: auto;
}
.tableWrap {
  flex: 1;
  padding-left: 20px;
  border-left: 1px solid #ddd;
}
.iconClose {
  display: none;
}
.hasValue:hover {
  .iconArrow {
    display: none;
  }
  .iconClose {
    display: inline-block;
  }
}
</style>

<style lang="scss">
.department_lh25 .el-input__icon {
  line-height: 25px!important;
}
.department_com .el-table__body tr.current-row > td.el-table__cell {
  background-color: #e6f2f2!important;
}
</style>